import { useEffect, useRef, useState } from 'react'
import api from '../../services/api'

export default function useCostEstimate(isOpen, accountId) {
    const [state, setState] = useState({ status: 'idle', accountId: null })
    const [revision, setRevision] = useState(0)
    const consumedRevision = useRef(0)
    useEffect(() => {
        if (!isOpen) {
            setState({ status: 'idle', accountId })
            return
        }
        let disposed = false
        let timer
        const controller = new AbortController()
        const deadline = Date.now() + 360000
        const refresh = revision !== consumedRevision.current
        consumedRevision.current = revision
        setState({ status: 'loading', accountId })
        const poll = async (first = false) => {
            try {
                if (Date.now() > deadline) throw new Error('estimate-timeout')
                const response = await api.get('/chat/official-api-cost-estimate', {
                    signal: controller.signal, timeout: 15000,
                    headers: { 'x-api-key': accountId },
                    params: first && refresh ? { refresh: true } : undefined,
                })
                if (disposed) return
                const data = response?.data?.data
                if (response.status === 202 || data?.status === 'processing') {
                    setState({ status: 'loading', accountId, progress: data?.progress })
                    timer = setTimeout(() => poll(), 1500)
                    return
                }
                if (!Array.isArray(data?.periods) || !Array.isArray(data?.inboxes)) throw new Error('invalid-estimate')
                setState({ status: 'ready', accountId, data })
            } catch (error) {
                if (disposed) return
                setState({ status: 'error', accountId,
                    error: error?.response?.data?.message || 'Não foi possível carregar o histórico. A consulta demorou mais que o esperado ou a conexão foi interrompida. Tente novamente.' })
            }
        }
        poll(true)
        return () => { disposed = true; clearTimeout(timer); controller.abort() }
    }, [isOpen, accountId, revision])
    const current = state.accountId === accountId ? state : { status: 'idle' }
    return {
        costEstimate: current.data || null,
        isLoadingEstimate: isOpen && ['idle', 'loading'].includes(current.status),
        estimateError: current.error || '',
        estimateProgress: current.progress,
        refreshEstimate: () => setRevision(value => value + 1),
    }
}
